// extracted by mini-css-extract-plugin
export default {"requests":"Archived_requests__P2yuT","chartRow":"Archived_chartRow__fjDSx","chart":"Archived_chart__FlkZ1"};